<template>
  <w-icon-wrapper
    :width='24'
    :height='21.6'
    icon-name='work-nav-report-icon'
    view-box='0 0 24 21.6'
  >
    <path
      id="_08_Auswertungen_Icon"
      data-name="08_Auswertungen_Icon"
      d="M82.4-820.8h4.8v-9.6H82.4Zm7.2,0h4.8v-16.8H89.6Zm7.2,0h4.8V-828H96.8ZM80-818.4v-14.4h7.2V-840h9.6v9.6H104v12Z"
      transform="translate(-80 840)"
      fill="currentColor"
    />
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconNavReport' };
</script>

